// https://echarts.apache.org/examples/zh/editor.html?c=pie-roseType
export default {
  name: '南丁格尔玫瑰图',
  options: {
    series: [
      {
        name: '半径模式',
        type: 'pie',
        radius: ['20%', '60%'],
        center: ['50%', '50%'],
        roseType: 'radius',
        label: {
          show: false
        },
        emphasis: {
          label: {
            show: true
          }
        },
        data: [
          { value: 10, name: 'rose1' },
          { value: 5, name: 'rose2' },
          { value: 15, name: 'rose3' },
          { value: 25, name: 'rose4' },
          { value: 20, name: 'rose5' },
          { value: 35, name: 'rose6' },
          { value: 30, name: 'rose7' },
          { value: 40, name: 'rose8' }
        ]
      }
    ]
  }
}
